const createClientIdempotencyKey = () => (
  globalThis.crypto?.randomUUID?.()
  || `checkout-${Date.now()}-${Math.random().toString(16).slice(2)}`
);

export const ensureCheckoutClientIdempotencyKey = (
  checkout,
  createKey = createClientIdempotencyKey,
) => {
  if (!checkout || checkout.client_idempotency_key) return checkout;
  return { ...checkout, client_idempotency_key: createKey() };
};

export const restoreCheckoutClientIdempotencyKey = (checkout, savedCheckout) => (
  ensureCheckoutClientIdempotencyKey(
    checkout,
    () => savedCheckout?.idempotencyKey || createClientIdempotencyKey(),
  )
);

const RECONCILIATION_ERROR_CODES = new Set([
  "payment_pending",
  "payment_failed",
  "checkout_failed",
  "combined_checkout_failed",
]);

export const checkoutRecoveryForError = (error) => {
  if (error?.checkoutRecovery) return error.checkoutRecovery;
  if (!RECONCILIATION_ERROR_CODES.has(error?.code)) return null;
  return {
    status: error.code === "payment_failed" ? "failed" : "pending",
    stage: "authorization_pending",
    recovery_actions: [],
    trace_id: error.traceId || null,
  };
};
